export default __webpack_public_path__ + "static/media/pp-eq-2.065f9401.png";